// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../srprsme-react-website/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
	FILE: _core.scss

	USED ON:
		- srprs.me/*

	USAGE:
		Meant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1

	NOTES:
		NEVER use @import "base/*"; or such, read this => http://stackoverflow.com/a/4779432
*/
.clearfix {
  overflow: auto;
}

.display-flex {
  display: inline;
}
@media only screen and (min-width: 767px) {
  .display-flex {
    display: flex;
  }
}

.full-width {
  width: 100%;
}

@media only screen and (max-width: 767px) {
  .mobile-full-width {
    width: 100%;
  }
}

@media only screen and (min-width: 767px) {
  .width-49 {
    width: 49%;
  }
}

.pull-left {
  float: left;
}

.pull-right {
  float: right;
}

.margin-b-s {
  margin-bottom: 10px;
}

.margin-b-m {
  margin-bottom: 20px;
}

.margin-b-l {
  margin-bottom: 40px;
}

.padding-t-s {
  padding-top: 10px;
}

.padding-t-s-7 {
  padding-top: 7px;
}

.padding-l-s {
  padding-left: 10px;
}

.padding-r-s {
  padding-right: 10px;
}

.padding-r-m {
  padding-right: 20px;
}

.padding-r-xl {
  padding-right: 60px;
}

.text-centered {
  text-align: center;
}

.text-bold {
  font-weight: bold;
}

.text-small {
  font-size: 14px;
}

.text-medium {
  font-size: 20px;
}

.text-large {
  font-size: 24px;
}

.text-xlarge {
  font-size: 28px;
}

.text-uppercase {
  text-transform: uppercase;
}

.is-loading,
.loading {
  color: #ececec;
  background-color: #ececec;
}
.is-loading::selection, .is-loading::-moz-selection,
.loading::selection,
.loading::-moz-selection {
  background: #ececec;
}

@media screen and (max-width: ) {
  body:before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 375px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 640px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 768px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1024px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1280px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1440px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
@media screen and (min-width: 1600px) {
  body::before {
    content: "mobile";
    display: none;
  }
}
/*
	usage:

	.element {
		@include browserfix(ie) {
			&:after {
				content: "This is IE only"
			}
		}
		@include browserfix(firefox) {
			&:after {
				content: "Only Firefox users will see this";
			}
		}
	}
*/
@keyframes buttonDisabled {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
.srprs-box {
  box-shadow: 0 0 12px 0 rgba(34, 34, 34, 0.15);
  padding: 12px;
  background: #fff;
  color: #222;
}
.srprs-box.is-fullWidthMobile {
  width: calc(100% + 40px);
  margin-left: -20px;
}
.srprs-box > footer {
  margin-bottom: -12px;
  margin-left: -12px;
  padding-top: 12px;
  padding-right: 12px;
  padding-bottom: 12px;
  padding-left: 12px;
  width: calc(100% + 24px);
  background-color: #e7e7e7;
}
.srprs-box > footer > div {
  max-width: 260px;
}
.srprs-box > footer > div:first-child {
  font-size: 14px;
}
.srprs-box > footer > div:first-child strong {
  font-size: 18px;
  font-family: font-body, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  font-weight: 800;
}
.srprs-box > footer > div:first-child span {
  float: right;
  margin-left: 12px;
}
.srprs-box > footer > div:last-child {
  transform: scale(0.7);
  margin-left: -39px;
}
.srprs-box.type-gloryColorHeaders, .srprs-box.type-tomatoHeaders, .srprs-box.type-blueHeaders, .srprs-box.type-celadon, .srprs-box.type-paleTurquoise, .srprs-box.type-shalimar, .srprs-box.type-golden, .srprs-box.type-lightPinkHeaders {
  padding: 20px 10px;
}
.srprs-box.type-gloryColorHeaders .srprs-icon-head, .srprs-box.type-tomatoHeaders .srprs-icon-head, .srprs-box.type-blueHeaders .srprs-icon-head, .srprs-box.type-celadon .srprs-icon-head, .srprs-box.type-paleTurquoise .srprs-icon-head, .srprs-box.type-shalimar .srprs-icon-head, .srprs-box.type-golden .srprs-icon-head, .srprs-box.type-lightPinkHeaders .srprs-icon-head {
  text-align: center;
  font-size: 70px;
  margin: 0;
}
.srprs-box.type-gloryColorHeaders .srprs-heading, .srprs-box.type-tomatoHeaders .srprs-heading, .srprs-box.type-blueHeaders .srprs-heading, .srprs-box.type-celadon .srprs-heading, .srprs-box.type-paleTurquoise .srprs-heading, .srprs-box.type-shalimar .srprs-heading, .srprs-box.type-golden .srprs-heading, .srprs-box.type-lightPinkHeaders .srprs-heading {
  font-weight: 800;
  margin-top: 10px;
  margin-bottom: 10px;
}
.srprs-box.type-gloryColorHeaders .content, .srprs-box.type-tomatoHeaders .content, .srprs-box.type-blueHeaders .content, .srprs-box.type-celadon .content, .srprs-box.type-paleTurquoise .content, .srprs-box.type-shalimar .content, .srprs-box.type-golden .content, .srprs-box.type-lightPinkHeaders .content {
  font-weight: 500;
}
.srprs-box.type-paleTurquoise .srprs-heading {
  color: #C5EFF4;
}
.srprs-box.type-golden .srprs-heading {
  color: #FFCB55;
}
.srprs-box.type-shalimar .srprs-heading {
  color: #F7F5B0;
}
.srprs-box.type-celadon .srprs-heading {
  color: #A7E8BB;
}
.srprs-box.type-gloryColorHeaders .srprs-heading {
  color: #91D1DA;
}
.srprs-box.type-tomatoHeaders .srprs-heading {
  color: #FF938C;
}
.srprs-box.type-lightPinkHeaders .srprs-heading {
  color: #f0c5ce;
}
.srprs-box.type-blueHeaders .srprs-heading {
  color: #0ECFC8;
}
.srprs-box.type-pattern {
  box-shadow: none;
  background: inherit;
  padding: 0;
  width: 100vw;
  margin-left: -20px;
}
.srprs-box.type-pattern .box-pattern {
  width: 100%;
  background-size: 34%;
  height: 300px;
}
.srprs-box.type-pattern .box-box {
  box-shadow: 0 0 12px 0 rgba(34, 34, 34, 0.15);
  padding: 30px;
  width: 95%;
  background: #fff;
  margin: 0 auto;
  margin-top: -250px;
}
.srprs-box.type-pattern .srprs-flipclock {
  font-size: initial;
}
.srprs-box.type-pattern .srprs-flipclock .tick-flip-card {
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
}
.srprs-box.type-pattern .box-countdown-number {
  display: flex;
  height: 64px;
}
.srprs-box.type-pattern .box-countdown-number > p {
  line-height: 40px;
}
.srprs-box.type-pattern .box-countdown-number .srprs-flipclock {
  width: 160px;
  margin: 0;
  padding-left: 20px;
  padding-right: 20px;
}
.srprs-box.type-pattern .box-countdown-number .srprs-flipclock > div {
  font-size: 28px !important;
}
.srprs-box.type-badge {
  transition: transform 0.25s;
  padding: 20px;
}
.srprs-box.type-badge > svg {
  width: 100%;
  margin-bottom: 40px;
}
.srprs-box.type-badge div {
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}
.srprs-box.type-badge div > span {
  font-size: 18px;
  font-weight: 700;
}
.srprs-box.type-badge div button.srprs-button {
  margin-left: auto;
  line-height: 30px;
  height: 40px;
  width: 48px;
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.srprs-box.type-badge div button.srprs-button .srprs-icon {
  width: 16px;
  height: 16px;
  bottom: -3px;
}
.srprs-box.type-badge:hover {
  transform: scale(1.02);
}
.srprs-box.colour-turquoise {
  background-color: #1ececa;
}
.srprs-box.colour-turquoise:hover div button.srprs-button {
  border-color: #1ececa;
}
.srprs-box.colour-turquoise:hover div button.srprs-button svg path {
  fill: #1ececa;
}
.srprs-box.colour-mint {
  background-color: #a0ddd2;
}
.srprs-box.colour-mint:hover div button.srprs-button {
  border-color: #a0ddd2;
}
.srprs-box.colour-mint:hover div button.srprs-button svg path {
  fill: #a0ddd2;
}
.srprs-box.colour-green {
  background-color: #bade94;
}
.srprs-box.colour-green:hover div button.srprs-button {
  border-color: #bade94;
}
.srprs-box.colour-green:hover div button.srprs-button svg path {
  fill: #bade94;
}
.srprs-box.colour-purple {
  background-color: #b599c6;
}
.srprs-box.colour-purple:hover div button.srprs-button {
  border-color: #b599c6;
}
.srprs-box.colour-purple:hover div button.srprs-button svg path {
  fill: #b599c6;
}
.srprs-box.colour-pink {
  background-color: #f87498;
}
.srprs-box.colour-pink:hover div button.srprs-button {
  border-color: #f87498;
}
.srprs-box.colour-pink:hover div button.srprs-button svg path {
  fill: #f87498;
}
.srprs-box.colour-blue {
  background-color: #00a0e0;
}
.srprs-box.colour-blue:hover div button.srprs-button {
  border-color: #00a0e0;
}
.srprs-box.colour-blue:hover div button.srprs-button svg path {
  fill: #00a0e0;
}
.srprs-box.colour-steel-blue {
  background-color: #a5bad6;
}
.srprs-box.colour-steel-blue:hover div button.srprs-button {
  border-color: #a5bad6;
}
.srprs-box.colour-steel-blue:hover div button.srprs-button svg path {
  fill: #a5bad6;
}
.srprs-box.colour-yellow {
  background-color: #f5ea47;
}
.srprs-box.colour-yellow:hover div button.srprs-button {
  border-color: #f5ea47;
}
.srprs-box.colour-yellow:hover div button.srprs-button svg path {
  fill: #f5ea47;
}
.srprs-box.colour-orange {
  background-color: #fac56d;
}
.srprs-box.colour-orange:hover div button.srprs-button {
  border-color: #fac56d;
}
.srprs-box.colour-orange:hover div button.srprs-button svg path {
  fill: #fac56d;
}
.srprs-box.colour-pink-light {
  background-color: #f0c5ce;
}
.srprs-box.colour-pink-light:hover div button.srprs-button {
  border-color: #f0c5ce;
}
.srprs-box.colour-pink-light:hover div button.srprs-button svg path {
  fill: #f0c5ce;
}
.srprs-box.colour-red {
  background-color: #f12535;
}
.srprs-box.colour-red:hover div button.srprs-button {
  border-color: #f12535;
}
.srprs-box.colour-red:hover div button.srprs-button svg path {
  fill: #f12535;
}
.srprs-box.colour-grey {
  background-color: #d3d3d3;
}
.srprs-box.colour-grey:hover div button.srprs-button {
  border-color: #d3d3d3;
}
.srprs-box.colour-grey:hover div button.srprs-button svg path {
  fill: #d3d3d3;
}
.srprs-box.colour-black {
  background-color: #222;
}
.srprs-box.colour-black:hover div button.srprs-button {
  border-color: #222;
}
.srprs-box.colour-black:hover div button.srprs-button svg path {
  fill: #222;
}
.srprs-box.colour-white {
  background-color: #fff;
}
.srprs-box.colour-white:hover div button.srprs-button {
  border-color: #fff;
}
.srprs-box.colour-white:hover div button.srprs-button svg path {
  fill: #fff;
}
.srprs-box.colour-blue-light {
  background-color: #aed7e8;
}
.srprs-box.colour-blue-light:hover div button.srprs-button {
  border-color: #aed7e8;
}
.srprs-box.colour-blue-light:hover div button.srprs-button svg path {
  fill: #aed7e8;
}
.srprs-box.colour-purple-light {
  background-color: #cfb9d2;
}
.srprs-box.colour-purple-light:hover div button.srprs-button {
  border-color: #cfb9d2;
}
.srprs-box.colour-purple-light:hover div button.srprs-button svg path {
  fill: #cfb9d2;
}
.srprs-box.colour-red-light {
  background-color: #E7024C;
}
.srprs-box.colour-red-light:hover div button.srprs-button {
  border-color: #E7024C;
}
.srprs-box.colour-red-light:hover div button.srprs-button svg path {
  fill: #E7024C;
}
.srprs-box.colour-tomato {
  background-color: #E56159;
}
.srprs-box.colour-tomato:hover div button.srprs-button {
  border-color: #E56159;
}
.srprs-box.colour-tomato:hover div button.srprs-button svg path {
  fill: #E56159;
}
.srprs-box.colour-coral {
  background-color: #F5661C;
}
.srprs-box.colour-coral:hover div button.srprs-button {
  border-color: #F5661C;
}
.srprs-box.colour-coral:hover div button.srprs-button svg path {
  fill: #F5661C;
}
.srprs-box.colour-tomato-section {
  background-color: #FF938C;
}
.srprs-box.colour-tomato-section:hover div button.srprs-button {
  border-color: #FF938C;
}
.srprs-box.colour-tomato-section:hover div button.srprs-button svg path {
  fill: #FF938C;
}
.srprs-box.colour-mint-v2 {
  background-color: #72BEA5;
}
.srprs-box.colour-mint-v2:hover div button.srprs-button {
  border-color: #72BEA5;
}
.srprs-box.colour-mint-v2:hover div button.srprs-button svg path {
  fill: #72BEA5;
}
.srprs-box.colour-turquoise-light {
  background-color: #C2E5ED;
}
.srprs-box.colour-turquoise-light:hover div button.srprs-button {
  border-color: #C2E5ED;
}
.srprs-box.colour-turquoise-light:hover div button.srprs-button svg path {
  fill: #C2E5ED;
}
.srprs-box.colour-almond {
  background-color: #F3D5CE;
}
.srprs-box.colour-almond:hover div button.srprs-button {
  border-color: #F3D5CE;
}
.srprs-box.colour-almond:hover div button.srprs-button svg path {
  fill: #F3D5CE;
}
.srprs-box.colour-cinderella {
  background-color: #FDE2DA;
}
.srprs-box.colour-cinderella:hover div button.srprs-button {
  border-color: #FDE2DA;
}
.srprs-box.colour-cinderella:hover div button.srprs-button svg path {
  fill: #FDE2DA;
}
.srprs-box.colour-humming-bird {
  background-color: #CDF2E6;
}
.srprs-box.colour-humming-bird:hover div button.srprs-button {
  border-color: #CDF2E6;
}
.srprs-box.colour-humming-bird:hover div button.srprs-button svg path {
  fill: #CDF2E6;
}
.srprs-box.colour-golden-tainoi {
  background-color: #FFCB55;
}
.srprs-box.colour-golden-tainoi:hover div button.srprs-button {
  border-color: #FFCB55;
}
.srprs-box.colour-golden-tainoi:hover div button.srprs-button svg path {
  fill: #FFCB55;
}
.srprs-box.colour-pale-turquoise {
  background-color: #C5EFF4;
}
.srprs-box.colour-pale-turquoise:hover div button.srprs-button {
  border-color: #C5EFF4;
}
.srprs-box.colour-pale-turquoise:hover div button.srprs-button svg path {
  fill: #C5EFF4;
}
.srprs-box.colour-celadon {
  background-color: #A7E8BB;
}
.srprs-box.colour-celadon:hover div button.srprs-button {
  border-color: #A7E8BB;
}
.srprs-box.colour-celadon:hover div button.srprs-button svg path {
  fill: #A7E8BB;
}
.srprs-box.colour-morning-glory {
  background-color: #91D1DA;
}
.srprs-box.colour-morning-glory:hover div button.srprs-button {
  border-color: #91D1DA;
}
.srprs-box.colour-morning-glory:hover div button.srprs-button svg path {
  fill: #91D1DA;
}
.srprs-box.colour-shalimar {
  background-color: #F7F5B0;
}
.srprs-box.colour-shalimar:hover div button.srprs-button {
  border-color: #F7F5B0;
}
.srprs-box.colour-shalimar:hover div button.srprs-button svg path {
  fill: #F7F5B0;
}

.cta-button .srprs-button.type-plain {
  height: 60px;
}

@media screen and (min-width: 375px) {
  .srprs-box > footer > div {
    float: left;
  }
  .srprs-box > footer > div + div {
    float: right;
  }
  .srprs-box > footer > div:first-child span {
    margin-left: 20px;
  }
  .srprs-box > footer > div:last-child {
    margin-left: auto;
    margin-right: -24px;
  }
}
@media screen and (min-width: 640px) {
  .srprs-box {
    padding: 24px;
  }
  .srprs-box > footer {
    margin-bottom: -24px;
    margin-left: -24px;
    padding-top: 24px;
    padding-right: 24px;
    padding-bottom: 24px;
    padding-left: 24px;
    width: calc(100% + 48px);
  }
  .srprs-box > footer > div:first-child {
    width: 200px;
    font-size: 16px;
  }
  .srprs-box > footer > div:first-child strong {
    font-size: 24px;
  }
  .srprs-box > footer > div:first-child span {
    float: right;
    margin-left: 20px;
  }
  .srprs-box > footer > div:last-child {
    transform: unset;
    margin: unset;
  }
  .srprs-box .box-countdown-number .srprs-flipclock > div {
    font-size: 78px !important;
  }
  .srprs-box.type-large {
    padding: 48px;
  }
  .srprs-box.type-large > footer {
    margin-bottom: -48px;
    margin-left: -48px;
    padding-top: 48px;
    padding-right: 48px;
    padding-bottom: 48px;
    padding-left: 48px;
    width: calc(100% + 96px);
  }
  .srprs-box.type-flavour, .srprs-box.type-celadon, .srprs-box.type-paleTurquoise, .srprs-box.type-shalimar, .srprs-box.type-golden, .srprs-box.type-gloryColorHeaders, .srprs-box.type-tomatoHeaders, .srprs-box.type-blueHeaders, .srprs-box.type-lightPinkHeaders, .srprs-box.type-halfWidthImage {
    padding: 70px 40px;
    font-size: 18px;
    line-height: 1.5em;
  }
  .srprs-box.type-flavour .srprs-heading, .srprs-box.type-celadon .srprs-heading, .srprs-box.type-paleTurquoise .srprs-heading, .srprs-box.type-shalimar .srprs-heading, .srprs-box.type-golden .srprs-heading, .srprs-box.type-gloryColorHeaders .srprs-heading, .srprs-box.type-tomatoHeaders .srprs-heading, .srprs-box.type-blueHeaders .srprs-heading, .srprs-box.type-lightPinkHeaders .srprs-heading, .srprs-box.type-halfWidthImage .srprs-heading {
    font-size: 26px;
  }
  .srprs-box.type-gloryColorHeaders, .srprs-box.type-tomatoHeaders, .srprs-box.type-celadon, .srprs-box.type-shalimar, .srprs-box.type-paleTurquoise, .srprs-box.type-golden, .srprs-box.type-blueHeaders, .srprs-box.type-lightPinkHeaders {
    padding: 40px;
  }
  .srprs-box.type-gloryColorHeaders .srprs-heading, .srprs-box.type-tomatoHeaders .srprs-heading, .srprs-box.type-celadon .srprs-heading, .srprs-box.type-shalimar .srprs-heading, .srprs-box.type-paleTurquoise .srprs-heading, .srprs-box.type-golden .srprs-heading, .srprs-box.type-blueHeaders .srprs-heading, .srprs-box.type-lightPinkHeaders .srprs-heading {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .srprs-box.type-halfWidthImage {
    position: relative;
    margin-top: 120px;
    margin-bottom: 180px;
    background-size: 50%;
    background-position: 100% 0;
    background-repeat: no-repeat;
  }
}
@media screen and (min-width: 768px) {
  .srprs-box.is-fullWidthMobile {
    width: 100%;
    margin-left: 0;
  }
  .srprs-box.type-badge {
    height: 280px;
    padding-top: 70px;
    padding-left: 50px;
    padding-bottom: 40px;
    padding-right: 50px;
  }
}
@media screen and (min-width: 1024px) {
  .srprs-box.type-pattern .box-countdown-number {
    display: flex;
    height: 104px;
  }
  .srprs-box.type-pattern .box-countdown-number > p {
    line-height: 102px;
  }
  .srprs-box.type-pattern .box-countdown-number .srprs-flipclock {
    width: auto;
    height: auto;
  }
  .srprs-box.type-pattern .box-countdown-number .srprs-flipclock > div {
    font-size: 78px !important;
  }
  .srprs-box.type-pattern {
    width: initial;
    margin-left: 0;
  }
  .srprs-box.type-pattern .box-box {
    padding-top: 65px;
    padding-left: 90px;
    padding-bottom: 45px;
    padding-right: 90px;
    margin-top: -308px;
    width: 880px;
  }
  .srprs-box.type-pattern .box-pattern {
    height: 388px;
  }
  .srprs-box.type-pattern h3.srprs-heading {
    font-size: 30px;
  }
  .srprs-box.type-pattern .srprs-flipclock {
    margin-top: 30px;
    padding-bottom: 45px;
  }
}`, "",{"version":3,"sources":["webpack://./../srprsme-react-components/src/components/_Assets/scss/_core.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/_helpers.scss","webpack://./../srprsme-react-components/src/components/Box/Box.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_breakpoint.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/mixins/_browser-fixes.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/animations/_Button.scss","webpack://./../srprsme-react-components/src/components/_Assets/scss/helpers/repeatables/_box-shadow.scss"],"names":[],"mappings":"AAEA;;;;;;;;;;;CAAA;ACAA;EACE,cAAA;ACWF;;ADRA;EACE,eAAA;ACWF;ADVE;EAFF;IAGI,aAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADTE;EADF;IAEI,WAAA;ECaF;AACF;;ADTE;EADF;IAEI,UAAA;ECaF;AACF;;ADVA;EACE,WAAA;ACaF;;ADVA;EACE,YAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADVA;EACE,gBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,mBAAA;ACaF;;ADVA;EACE,kBAAA;ACaF;;ADVA;EACE,iBAAA;ACaF;;ADXA;EACE,eAAA;ACcF;;ADZA;EACE,eAAA;ACeF;;ADbA;EACE,eAAA;ACgBF;;ADdA;EACE,eAAA;ACiBF;;ADfA;EACE,yBAAA;ACkBF;;ADfA;;EAEE,cAAA;EACA,yBAAA;ACkBF;ADjBE;;;EAEE,mBAAA;ACoBJ;;ACpFA;EAEI;IACE,iBAAA;IACA,aAAA;EDsFJ;AACF;ACvHI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDoEN;AACF;AC7HI;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED0EN;AACF;ACnII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDgFN;AACF;ACzII;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDsFN;AACF;AC/II;EAwCE;IAcI,iBAAA;IAEF,aAAA;ED4FN;AACF;ACrJI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDkGN;AACF;AC3JI;EAwCE;IAcI,iBAAA;IAEF,aAAA;EDwGN;AACF;AEzIA;;;;;;;;;;;;;;;CAAA;AChCA;EACE;IAEE,kCAAA;EH0LF;EGxLA;IAEE,iCAAA;EHyLF;EGvLA;IAGE,kCAAA;EHuLF;EGrLA;IAEE,iCAAA;EHsLF;AACF;AApMA;EISI,6CAAA;EJPF,aAAA;EACA,gBAAA;EACA,WAAA;AAsMF;AArME;EACE,wBAAA;EAEE,kBAAA;AAsMN;AAlME;EAEI,oBAAA;EACA,kBAAA;EAGA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EAEF,wBAAA;EAEE,yBAAA;AA+LN;AA7LI;EACE,gBAAA;AA+LN;AA7LI;EAEI,eAAA;AA8LR;AA5LM;EAEI,eAAA;EACA,2IAAA;EACA,gBAAA;AA6LV;AA1LM;EACE,YAAA;EACA,iBAAA;AA4LR;AAzLI;EACE,qBAAA;EACA,kBAAA;AA2LN;AAxLE;EAQE,kBAAA;AAmLJ;AAlLI;EACE,kBAAA;EACA,eAAA;EACA,SAAA;AAoLN;AAlLI;EACE,gBAAA;EAEE,gBAAA;EACA,mBAAA;AAmLR;AAhLI;EACE,gBAAA;AAkLN;AA9KI;EACE,cAAA;AAgLN;AA5KI;EACE,cAAA;AA8KN;AA1KI;EACE,cAAA;AA4KN;AAxKI;EACE,cAAA;AA0KN;AAtKI;EACE,cAAA;AAwKN;AApKI;EACE,cAAA;AAsKN;AAlKI;EACE,cAAA;AAoKN;AAhKI;EACE,cAAA;AAkKN;AA/JE;EACE,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;AAiKJ;AAhKI;EACE,WAAA;EACA,oBAAA;EACA,aAAA;AAkKN;AAhKI;EItHA,6CAAA;EJwHE,aAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAkKN;AAhKI;EAIE,kBAAA;AA+JN;AAlKM;EACE,uCAAA;AAoKR;AAhKI;EACE,aAAA;EACA,YAAA;AAkKN;AAhKM;EACE,iBAAA;AAkKR;AA/JM;EACE,YAAA;EACA,SAAA;EAEE,kBAAA;EACA,mBAAA;AAgKV;AA9JQ;EACE,0BAAA;AAgKV;AA3JE;EACE,2BAAA;EACA,aAAA;AA6JJ;AA5JI;EACE,WAAA;EACA,mBAAA;AA8JN;AA3JI;EACE,oBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AA6JN;AA3JM;EAEI,eAAA;EACA,gBAAA;AA4JV;AAxJM;EACE,iBAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EAEE,6BAAA;EACA,8BAAA;AAyJV;AAvJQ;EACE,WAAA;EACA,YAAA;EACA,YAAA;AAyJV;AApJI;EACE,sBAAA;AAsJN;AAjJI;EACE,yBAAA;AAmJN;AAhJQ;EACE,qBAAA;AAkJV;AAjJU;EACE,aAAA;AAmJZ;AA1JI;EACE,yBAAA;AA4JN;AAzJQ;EACE,qBAAA;AA2JV;AA1JU;EACE,aAAA;AA4JZ;AAnKI;EACE,yBAAA;AAqKN;AAlKQ;EACE,qBAAA;AAoKV;AAnKU;EACE,aAAA;AAqKZ;AA5KI;EACE,yBAAA;AA8KN;AA3KQ;EACE,qBAAA;AA6KV;AA5KU;EACE,aAAA;AA8KZ;AArLI;EACE,yBAAA;AAuLN;AApLQ;EACE,qBAAA;AAsLV;AArLU;EACE,aAAA;AAuLZ;AA9LI;EACE,yBAAA;AAgMN;AA7LQ;EACE,qBAAA;AA+LV;AA9LU;EACE,aAAA;AAgMZ;AAvMI;EACE,yBAAA;AAyMN;AAtMQ;EACE,qBAAA;AAwMV;AAvMU;EACE,aAAA;AAyMZ;AAhNI;EACE,yBAAA;AAkNN;AA/MQ;EACE,qBAAA;AAiNV;AAhNU;EACE,aAAA;AAkNZ;AAzNI;EACE,yBAAA;AA2NN;AAxNQ;EACE,qBAAA;AA0NV;AAzNU;EACE,aAAA;AA2NZ;AAlOI;EACE,yBAAA;AAoON;AAjOQ;EACE,qBAAA;AAmOV;AAlOU;EACE,aAAA;AAoOZ;AA3OI;EACE,yBAAA;AA6ON;AA1OQ;EACE,qBAAA;AA4OV;AA3OU;EACE,aAAA;AA6OZ;AApPI;EACE,yBAAA;AAsPN;AAnPQ;EACE,qBAAA;AAqPV;AApPU;EACE,aAAA;AAsPZ;AA7PI;EACE,sBAAA;AA+PN;AA5PQ;EACE,kBAAA;AA8PV;AA7PU;EACE,UAAA;AA+PZ;AAtQI;EACE,sBAAA;AAwQN;AArQQ;EACE,kBAAA;AAuQV;AAtQU;EACE,UAAA;AAwQZ;AA/QI;EACE,yBAAA;AAiRN;AA9QQ;EACE,qBAAA;AAgRV;AA/QU;EACE,aAAA;AAiRZ;AAxRI;EACE,yBAAA;AA0RN;AAvRQ;EACE,qBAAA;AAyRV;AAxRU;EACE,aAAA;AA0RZ;AAjSI;EACE,yBAAA;AAmSN;AAhSQ;EACE,qBAAA;AAkSV;AAjSU;EACE,aAAA;AAmSZ;AA1SI;EACE,yBAAA;AA4SN;AAzSQ;EACE,qBAAA;AA2SV;AA1SU;EACE,aAAA;AA4SZ;AAnTI;EACE,yBAAA;AAqTN;AAlTQ;EACE,qBAAA;AAoTV;AAnTU;EACE,aAAA;AAqTZ;AA5TI;EACE,yBAAA;AA8TN;AA3TQ;EACE,qBAAA;AA6TV;AA5TU;EACE,aAAA;AA8TZ;AArUI;EACE,yBAAA;AAuUN;AApUQ;EACE,qBAAA;AAsUV;AArUU;EACE,aAAA;AAuUZ;AA9UI;EACE,yBAAA;AAgVN;AA7UQ;EACE,qBAAA;AA+UV;AA9UU;EACE,aAAA;AAgVZ;AAvVI;EACE,yBAAA;AAyVN;AAtVQ;EACE,qBAAA;AAwVV;AAvVU;EACE,aAAA;AAyVZ;AAhWI;EACE,yBAAA;AAkWN;AA/VQ;EACE,qBAAA;AAiWV;AAhWU;EACE,aAAA;AAkWZ;AAzWI;EACE,yBAAA;AA2WN;AAxWQ;EACE,qBAAA;AA0WV;AAzWU;EACE,aAAA;AA2WZ;AAlXI;EACE,yBAAA;AAoXN;AAjXQ;EACE,qBAAA;AAmXV;AAlXU;EACE,aAAA;AAoXZ;AA3XI;EACE,yBAAA;AA6XN;AA1XQ;EACE,qBAAA;AA4XV;AA3XU;EACE,aAAA;AA6XZ;AApYI;EACE,yBAAA;AAsYN;AAnYQ;EACE,qBAAA;AAqYV;AApYU;EACE,aAAA;AAsYZ;AA7YI;EACE,yBAAA;AA+YN;AA5YQ;EACE,qBAAA;AA8YV;AA7YU;EACE,aAAA;AA+YZ;AAtZI;EACE,yBAAA;AAwZN;AArZQ;EACE,qBAAA;AAuZV;AAtZU;EACE,aAAA;AAwZZ;;AA9YI;EACE,YAAA;AAiZN;;AChnBI;EDuOE;IACE,WAAA;EA6YN;EA5YM;IACE,YAAA;EA8YR;EA1YM;IACE,iBAAA;EA4YR;EAzYI;IAEI,iBAAA;IACA,mBAAA;EA0YR;AACF;AChoBI;ED6PF;IACE,aAAA;EAsYF;EArYE;IAEI,oBAAA;IACA,kBAAA;IAGA,iBAAA;IACA,mBAAA;IACA,oBAAA;IACA,kBAAA;IAEF,wBAAA;EAmYJ;EAjYI;IACE,YAAA;IAEE,eAAA;EAkYR;EA/XM;IAEI,eAAA;EAgYV;EA7XM;IACE,YAAA;IACA,iBAAA;EA+XR;EA5XI;IACE,gBAAA;IACA,aAAA;EA8XN;EAzXM;IACE,0BAAA;EA2XR;EAvXE;IACE,aAAA;EAyXJ;EAvXI;IAEI,oBAAA;IACA,kBAAA;IAGA,iBAAA;IACA,mBAAA;IACA,oBAAA;IACA,kBAAA;IAEF,wBAAA;EAqXN;EAlXE;IAUE,kBAAA;IACA,eAAA;IACA,kBAAA;EA2WJ;EA1WI;IACE,eAAA;EA4WN;EAzWE;IAQE,aAAA;EAoWJ;EAnWI;IAEI,gBAAA;IACA,mBAAA;EAoWR;EAhWE;IACE,kBAAA;IAEE,iBAAA;IACA,oBAAA;IAGA,oBAAA;IACA,2BAAA;IACA,4BAAA;EA+VN;AACF;ACnsBI;ED2WA;IACE,WAAA;IAEE,cAAA;EA0VN;EAtVE;IACE,aAAA;IAEE,iBAAA;IACA,kBAAA;IACA,oBAAA;IACA,mBAAA;EAuVN;AACF;AChtBI;EDiYE;IACE,aAAA;IACA,aAAA;EAkVN;EAhVM;IACE,kBAAA;EAkVR;EA/UM;IACE,WAAA;IACA,YAAA;EAiVR;EAhVQ;IACE,0BAAA;EAkVV;EA7UE;IACE,cAAA;IACA,cAAA;EA+UJ;EA9UI;IAEI,iBAAA;IACA,kBAAA;IACA,oBAAA;IACA,mBAAA;IAEF,kBAAA;IACA,YAAA;EA8UN;EA5UI;IACE,aAAA;EA8UN;EA5UI;IACE,eAAA;EA8UN;EA5UI;IACE,gBAAA;IACA,oBAAA;EA8UN;AACF","sourcesContent":["@charset \"UTF-8\";\n\n/*\n\tFILE: _core.scss\n\n\tUSED ON:\n\t\t- srprs.me/*\n\n\tUSAGE:\n\t\tMeant for 'sitewide' stylesheets aka stylesheets that are needed on every page. Please be careful with this one, don't add unnecessary partials when they're not needed on every page since this slows down the loading/rendering time!!!1!1\n\n\tNOTES:\n\t\tNEVER use @import \"base/*\"; or such, read this => http://stackoverflow.com/a/4779432\n*/\n\n// vars & helpers\n@import 'helpers/variables';\n@import 'helpers/helpers';\n\n// functions\n@import 'helpers/functions/map-deep-get';\n@import 'helpers/functions/color';\n@import 'helpers/functions/font';\n//@import \"helpers/functions/padding\";\n@import 'helpers/functions/section';\n@import 'helpers/functions/str-replace';\n@import 'helpers/functions/z-index';\n\n// mixins\n@import 'helpers/mixins/arrow';\n@import 'helpers/mixins/aspect-ratio';\n@import 'helpers/mixins/breakpoint';\n@import 'helpers/mixins/browser-fixes';\n@import 'helpers/mixins/color-schemes';\n@import 'helpers/mixins/grid';\n@import 'helpers/mixins/no-bullets';\n@import 'helpers/mixins/clearfix';\n@import 'helpers/mixins/font-face';\n@import 'helpers/mixins/scrollbars';\n@import 'helpers/mixins/transform-center';\n@import 'helpers/mixins/transition';\n@import 'helpers/mixins/truncate';\n\n// repeatables (aka think DRY and store it in an @mixin)\n@import 'helpers/repeatables/box-shadow';\n@import 'helpers/repeatables/iphonex';\n@import 'helpers/repeatables/wrapper-inner';\n\n// animations\n@import 'animations/Button';\n","@charset \"UTF-8\";\n\n.clearfix {\n  overflow: auto;\n}\n\n.display-flex {\n  display: inline;\n  @media only screen and (min-width: 767px) {\n    display: flex;\n  }\n}\n\n.full-width {\n  width: 100%;\n}\n\n.mobile-full-width {\n  @media only screen and (max-width: 767px) {\n    width: 100%;\n  }\n}\n\n.width-49 {\n  @media only screen and (min-width: 767px) {\n    width: 49%;\n  }\n}\n\n.pull-left {\n  float: left;\n}\n\n.pull-right {\n  float: right;\n}\n\n.margin-b-s {\n  margin-bottom: 10px;\n}\n\n.margin-b-m {\n  margin-bottom: 20px;\n}\n\n.margin-b-l {\n  margin-bottom: 40px;\n}\n\n.padding-t-s {\n  padding-top: 10px;\n}\n\n.padding-t-s-7 {\n  padding-top: 7px;\n}\n\n.padding-l-s {\n  padding-left: 10px;\n}\n\n.padding-r-s {\n  padding-right: 10px;\n}\n\n.padding-r-m {\n  padding-right: 20px;\n}\n\n.padding-r-xl {\n  padding-right: 60px;\n}\n\n.text-centered {\n  text-align: center;\n}\n\n.text-bold {\n  font-weight: bold;\n}\n.text-small {\n  font-size: 14px;\n}\n.text-medium {\n  font-size: 20px;\n}\n.text-large {\n  font-size: 24px;\n}\n.text-xlarge {\n  font-size: 28px;\n}\n.text-uppercase {\n  text-transform: uppercase;\n}\n\n.is-loading,\n.loading {\n  color: #ececec;\n  background-color: #ececec;\n  &::selection,\n  &::-moz-selection {\n    background: #ececec;\n  }\n}\n","@charset \"UTF-8\";\n\n@import '../_Assets/scss/core';\n@include color-schemes;\n\n.srprs-box {\n  @include box-shadow();\n  padding: 12px;\n  background: color(white);\n  color: color(black);\n  &.is-fullWidthMobile {\n    width: calc(100% + 40px);\n    margin: {\n      left: -20px;\n    }\n  }\n\n  > footer {\n    margin: {\n      bottom: -12px;\n      left: -12px;\n    }\n    padding: {\n      top: 12px;\n      right: 12px;\n      bottom: 12px;\n      left: 12px;\n    }\n    width: calc(100% + 24px);\n    background: {\n      color: color(grey-light);\n    }\n    > div {\n      max-width: 260px;\n    }\n    > div:first-child {\n      font: {\n        size: 14px;\n      }\n      strong {\n        font: {\n          size: 18px;\n          family: font(heading);\n          weight: 800;\n        }\n      }\n      span {\n        float: right;\n        margin-left: 12px;\n      }\n    }\n    > div:last-child {\n      transform: scale(0.7);\n      margin-left: -39px;\n    }\n  }\n  &.type-gloryColorHeaders,\n  &.type-tomatoHeaders,\n  &.type-blueHeaders,\n  &.type-celadon,\n  &.type-paleTurquoise,\n  &.type-shalimar,\n  &.type-golden,\n  &.type-lightPinkHeaders {\n    padding: 20px 10px;\n    .srprs-icon-head {\n      text-align: center;\n      font-size: 70px;\n      margin: 0;\n    }\n    .srprs-heading {\n      font-weight: 800;\n      margin: {\n        top: 10px;\n        bottom: 10px;\n      }\n    }\n    .content {\n      font-weight: 500;\n    }\n  }\n  &.type-paleTurquoise {\n    .srprs-heading {\n      color: color(pale-turquoise);\n    }\n  }\n  &.type-golden {\n    .srprs-heading {\n      color: color(golden-tainoi);\n    }\n  }\n  &.type-shalimar {\n    .srprs-heading {\n      color: color(shalimar);\n    }\n  }\n  &.type-celadon {\n    .srprs-heading {\n      color: color(celadon);\n    }\n  }\n  &.type-gloryColorHeaders {\n    .srprs-heading {\n      color: color(morning-glory);\n    }\n  }\n  &.type-tomatoHeaders {\n    .srprs-heading {\n      color: color(tomato-section);\n    }\n  }\n  &.type-lightPinkHeaders {\n    .srprs-heading {\n      color: color(pink-light);\n    }\n  }\n  &.type-blueHeaders {\n    .srprs-heading {\n      color: color(mint-blue);\n    }\n  }\n  &.type-pattern {\n    box-shadow: none;\n    background: inherit;\n    padding: 0;\n    width: 100vw;\n    margin-left: -20px;\n    .box-pattern {\n      width: 100%;\n      background-size: 34%;\n      height: 300px;\n    }\n    .box-box {\n      @include box-shadow();\n      padding: 30px;\n      width: 95%;\n      background: color(white);\n      margin: 0 auto;\n      margin-top: -250px;\n    }\n    .srprs-flipclock {\n      .tick-flip-card {\n        box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);\n      }\n      font-size: initial;\n    }\n    .box-countdown-number {\n      display: flex;\n      height: 64px;\n\n      > p {\n        line-height: 40px;\n      }\n\n      .srprs-flipclock {\n        width: 160px;\n        margin: 0;\n        padding: {\n          left: 20px;\n          right: 20px;\n        }\n        & > div {\n          font-size: 28px !important;\n        }\n      }\n    }\n  }\n  &.type-badge {\n    transition: transform 0.25s;\n    padding: 20px;\n    > svg {\n      width: 100%;\n      margin-bottom: 40px;\n    }\n\n    div {\n      display: inline-flex;\n      flex-direction: row;\n      align-items: center;\n      width: 100%;\n\n      > span {\n        font: {\n          size: 18px;\n          weight: 700;\n        }\n      }\n\n      button.srprs-button {\n        margin-left: auto;\n        line-height: 30px;\n        height: 40px;\n        width: 48px;\n        padding: {\n          left: 10px !important;\n          right: 10px !important;\n        }\n        .srprs-icon {\n          width: 16px;\n          height: 16px;\n          bottom: -3px;\n        }\n      }\n    }\n\n    &:hover {\n      transform: scale(1.02);\n    }\n  }\n\n  @each $color, $x in $list-colorschemes {\n    &.colour-#{\"\" + $color} {\n      background-color: color($color);\n\n      &:hover {\n        div button.srprs-button {\n          border-color: #{color($color)};\n          svg path {\n            fill: #{color($color)};\n          }\n        }\n      }\n    }\n  }\n}\n\n.cta-button {\n  .srprs-button {\n    &.type-plain {\n      height: 60px;\n    }\n  }\n}\n\n@include breakpoint(mobile-large) {\n  .srprs-box {\n    > footer {\n      > div {\n        float: left;\n        & + div {\n          float: right;\n        }\n      }\n      > div:first-child {\n        span {\n          margin-left: 20px;\n        }\n      }\n      > div:last-child {\n        margin: {\n          left: auto;\n          right: -24px;\n        }\n      }\n    }\n  }\n}\n\n@include breakpoint(mobile-landscape) {\n  .srprs-box {\n    padding: 24px;\n    > footer {\n      margin: {\n        bottom: -24px;\n        left: -24px;\n      }\n      padding: {\n        top: 24px;\n        right: 24px;\n        bottom: 24px;\n        left: 24px;\n      }\n      width: calc(100% + 48px);\n\n      > div:first-child {\n        width: 200px;\n        font: {\n          size: 16px;\n        }\n\n        strong {\n          font: {\n            size: 24px;\n          }\n        }\n        span {\n          float: right;\n          margin-left: 20px;\n        }\n      }\n      > div:last-child {\n        transform: unset;\n        margin: unset;\n      }\n    }\n    .box-countdown-number {\n      .srprs-flipclock {\n        & > div {\n          font-size: 78px !important;\n        }\n      }\n    }\n    &.type-large {\n      padding: 48px;\n\n      > footer {\n        margin: {\n          bottom: -48px;\n          left: -48px;\n        }\n        padding: {\n          top: 48px;\n          right: 48px;\n          bottom: 48px;\n          left: 48px;\n        }\n        width: calc(100% + 96px);\n      }\n    }\n    &.type-flavour,\n    &.type-celadon,\n    &.type-paleTurquoise,\n    &.type-shalimar,\n    &.type-golden,\n    &.type-gloryColorHeaders,\n    &.type-tomatoHeaders,\n    &.type-blueHeaders,\n    &.type-lightPinkHeaders,\n    &.type-halfWidthImage {\n      padding: 70px 40px;\n      font-size: 18px;\n      line-height: 1.5em;\n      .srprs-heading {\n        font-size: 26px;\n      }\n    }\n    &.type-gloryColorHeaders,\n    &.type-tomatoHeaders,\n    &.type-celadon,\n    &.type-shalimar,\n    &.type-paleTurquoise,\n    &.type-golden,\n    &.type-blueHeaders,\n    &.type-lightPinkHeaders {\n      padding: 40px;\n      .srprs-heading {\n        margin: {\n          top: 20px;\n          bottom: 20px;\n        }\n      }\n    }\n    &.type-halfWidthImage {\n      position: relative;\n      margin: {\n        top: 120px;\n        bottom: 180px;\n      }\n      background: {\n        size: 50%;\n        position: 100% 0;\n        repeat: no-repeat;\n      }\n    }\n  }\n}\n\n@include breakpoint(tablet-portrait) {\n  .srprs-box {\n    &.is-fullWidthMobile {\n      width: 100%;\n      margin: {\n        left: 0;\n      }\n    }\n\n    &.type-badge {\n      height: 280px;\n      padding: {\n        top: 70px;\n        left: 50px;\n        bottom: 40px;\n        right: 50px;\n      }\n    }\n  }\n}\n\n@include breakpoint(tablet-landscape) {\n  .srprs-box {\n    &.type-pattern {\n      .box-countdown-number {\n        display: flex;\n        height: 104px;\n\n        > p {\n          line-height: 102px;\n        }\n\n        .srprs-flipclock {\n          width: auto;\n          height: auto;\n          & > div {\n            font-size: 78px !important;\n          }\n        }\n      }\n    }\n    &.type-pattern {\n      width: initial;\n      margin-left: 0;\n      .box-box {\n        padding: {\n          top: 65px;\n          left: 90px;\n          bottom: 45px;\n          right: 90px;\n        }\n        margin-top: -308px;\n        width: section(max-width-s);\n      }\n      .box-pattern {\n        height: 388px;\n      }\n      h3.srprs-heading {\n        font-size: 30px;\n      }\n      .srprs-flipclock {\n        margin-top: 30px;\n        padding-bottom: 45px;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n$breakpoints: map-deep-get($srprsreactwebsite-config, 'breakpoints');\n\n@mixin breakpoint($screensize) {\n  @if map-has-key($breakpoints, $screensize) {\n    @media screen and (min-width: map-get($breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (min-width: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$height-breakpoints: map-deep-get(\n  $srprsreactwebsite-config,\n  'height-breakpoints'\n);\n\n@mixin height-breakpoint($screensize) {\n  @if map-has-key($height-breakpoints, $screensize) {\n    @media screen and (max-height: map-get($height-breakpoints, $screensize)) {\n      @content;\n    }\n  } @else {\n    @media screen and (max-height: #{$screensize}) {\n      @content;\n    }\n  }\n}\n\n$breakpoint-initial: map-deep-get(\n  $srprsreactwebsite-config,\n  'breakpoints',\n  's'\n);\n@media screen and (max-width: $breakpoint-initial) {\n  body {\n    &:before {\n      content: 'mobile';\n      display: none;\n    }\n  }\n}\n\n@each $breakpoint, $screensize in $breakpoints {\n  @include breakpoint(#{$screensize}) {\n    body {\n      &::before {\n        @if $breakpoint ==\n          l or\n          $breakpoint ==\n          xl or\n          $breakpoint ==\n          xxl or\n          $breakpoint ==\n          xxxl\n        {\n          content: 'desktop';\n        } @else if $breakpoint == m {\n          content: 'tablet';\n        } @else {\n          content: 'mobile';\n        }\n        display: none;\n      }\n    }\n  }\n}\n","@charset \"UTF-8\";\n\n// we should thank http://browserhacks.com/ for this great roundup of dirt\n\n@mixin browserfix($browser) {\n  @if ($browser == 'ie') {\n    // the allmighty IE, 10 and up. 9 and lower requires usage of conditional comments, just stash your code in assets/styles/ie.scss\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n      @content;\n    }\n  } @else if ($browser == 'firefox') {\n    // firefox 3 and up\n    @-moz-document url-prefix() {\n      @content;\n    }\n  } @else if ($browser == 'opera') {\n    // opera 9.5 and up\n    _:-o-prefocus,\n    body:last-child .selector {\n      @content;\n    }\n  } @else if ($browser == 'safari') {\n    // all safari\n    .selector:not(*:root) {\n      @content;\n    }\n  } @else if ($browser == 'chrome') {\n    // chrome 28 and up\n    @supports (-webkit-appearance: none) {\n      @content;\n    }\n  }\n}\n\n/*\n\tusage:\n\n\t.element {\n\t\t@include browserfix(ie) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"This is IE only\"\n\t\t\t}\n\t\t}\n\t\t@include browserfix(firefox) {\n\t\t\t&:after {\n\t\t\t\tcontent: \"Only Firefox users will see this\";\n\t\t\t}\n\t\t}\n\t}\n*/\n","@charset \"UTF-8\";\n\n@keyframes buttonDisabled {\n  10%,\n  90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n  20%,\n  80% {\n    transform: translate3d(2px, 0, 0);\n  }\n  30%,\n  50%,\n  70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n  40%,\n  60% {\n    transform: translate3d(4px, 0, 0);\n  }\n}\n","@charset \"UTF-8\";\n\n$box-shadow: map-deep-get($srprsreactwebsite-config, 'box-shadow');\n\n@mixin box-shadow(\n  $blur: map-deep-get($srprsreactwebsite-config, 'box-shadow', 'blur-default')\n) {\n  @if map-has-key($box-shadow, $blur) {\n    box-shadow: 0\n      0\n      map-deep-get($srprsreactwebsite-config, 'box-shadow', $blur)\n      0\n      rgba(color(black), 0.15);\n  } @else {\n    box-shadow: 0\n      0\n      map-deep-get($srprsreactwebsite-config, 'box-shadow', 'blur-default')\n      0\n      rgba(color(black), 0.15);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
